export const MIXPANEL_EVENT_ALLOWLIST = {
  page_view: [
    "path",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  feature_used: [
    "feature",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  button_click: [
    "button_id",
    "label",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  link_click: [
    "link_path",
    "label",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  element_hover: [
    "element_type",
    "element_id",
    "label",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  form_submit: [
    "form_id",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  form_abandon: [
    "form_id",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  input_focus: [
    "input_id",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  time_on_page: [
    "page",
    "duration_seconds",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  search_results: [
    "query_length",
    "results_count",
    "has_results",
    "scope",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  funnel_step: [
    "funnel",
    "step",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  data_load_time: [
    "stage",
    "duration_ms",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  performance_metric: [
    "name",
    "value",
    "unit",
    "bucket",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  error_event: [
    "error_type",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  report_export: [
    "report_type",
    "filters",
    "page",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  terms_gate_accept: ["page", "role"],
  terms_gate_exit: ["page", "role", "reason"],
  demo_signup_view: ["page", "step_key", "step_index", "total_steps"],
  demo_signup_step_view: [
    "page",
    "step_key",
    "step_index",
    "total_steps",
    "required",
    "input_type",
  ],
  demo_signup_step_complete: [
    "page",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
    "step_key",
    "step_index",
    "duration_ms",
    "duration_bucket",
    "value_length",
    "selected_value",
    "required",
    "input_type",
  ],
  demo_signup_step_back: [
    "page",
    "from_step",
    "to_step",
    "duration_ms",
  ],
  demo_signup_step_skip: ["page", "step_key", "step_index", "duration_ms"],
  demo_signup_validation_error: [
    "page",
    "step_key",
    "step_index",
    "error_type",
  ],
  demo_signup_submit: [
    "page",
    "total_duration_ms",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
  ],
  demo_signup_success: [
    "page",
    "total_duration_ms",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
  ],
  demo_signup_error: [
    "page",
    "error_type",
    "status_code",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
  ],
  demo_signup_auth_start: ["page", "method", "delay_ms"],
  demo_signup_auth_success: ["page", "method", "duration_ms"],
  demo_signup_auth_failure: ["page", "method"],
  demo_signup_abandon: [
    "page",
    "step_key",
    "step_index",
    "total_duration_ms",
    "step_duration_ms",
    "had_errors",
    "success",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
  ],
  demo_signup_entry: [
    "page",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "referrer_class",
  ],
  demo_signup_rage_click: [
    "page",
    "button_id",
    "click_count",
    "window_ms",
    "step_key",
    "step_index",
  ],
  demo_signup_repeated_error: [
    "page",
    "step_key",
    "step_index",
    "error_type",
    "count",
  ],
  demo_signup_first_page: ["page", "delay_ms", "source"],
  demo_booking_open: [
    "page",
    "variant",
    "demo_origin",
    "delay_ms",
  ],
  demo_booking_step_view: [
    "page",
    "step_key",
    "step_index",
    "total_steps",
    "required",
    "input_type",
  ],
  demo_booking_step_complete: [
    "page",
    "step_key",
    "step_index",
    "duration_ms",
    "value_length",
    "selected_value",
    "required",
    "input_type",
  ],
  demo_booking_step_back: ["page", "from_step", "to_step", "duration_ms"],
  demo_booking_validation_error: [
    "page",
    "step_key",
    "step_index",
    "error_type",
  ],
  demo_booking_schedule_click: [
    "page",
    "duration_ms",
    "total_duration_ms",
    "variant",
    "demo_origin",
    "delay_ms",
  ],
  demo_signup_to_booking: ["page", "delay_ms"],
  demo_booking_close: ["page", "reason", "duration_ms", "variant", "completed"],
  demo_booking_abandon: [
    "page",
    "step_key",
    "step_index",
    "total_duration_ms",
    "step_duration_ms",
    "variant",
  ],
  session_first_page: [
    "page",
    "total_pages",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  session_second_page: [
    "page",
    "total_pages",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  page_exit: [
    "page",
    "duration_ms",
    "reason",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  session_pages_summary: [
    "first_page",
    "second_page",
    "last_page",
    "total_pages",
    "longest_page",
    "longest_duration_ms",
    "shortest_page",
    "shortest_duration_ms",
    "session_duration_ms",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  session_duration: [
    "duration_ms",
    "total_pages",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  session_first_action: [
    "page",
    "duration_ms",
    "action_type",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  demo_return: [
    "page",
    "hours_since_signup",
    "return_bucket",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  demo_first_feature_used: [
    "page",
    "feature",
    "delay_ms",
    "role",
    "is_demo",
    "city",
    "country",
    "school_id",
    "district_id",
    "timezone",
    "locale",
  ],
  identify_complete: ["page"],
  wellness_summary: [
    "period",
    "total",
    "top_emotion",
    "top_action",
    "helpful_rate",
    "role",
    "is_demo",
  ],
};

export const RED_FLAG_FIELDS = [
  // Direct identifiers
  "email",
  "name",
  "username",
  "password",
  "studentId",
  "userId",
  "student_id",
  "user_id",
  "phone",
  "telephone",
  "address",
  "zip",
  "zipcode",
  "postal_code",
  // Device identifiers (blocking only identifying ones)
  "device_id",
  "deviceId",
  "device_fingerprint",
  "fingerprint",
  "browser_id",
  "session_id",
  "ip",
  "ip_address",
  "user_agent", // Full user agent can be identifying
  "userAgent",
  // Allowed: platform, os, browser, screen_width, screen_height, referrer, referring_domain, current_url
  // These are helpful for analytics and not identifying on their own
  "browser_version", // Can be identifying when combined
  "screen_resolution", // Exact resolution can be identifying
  "screen_size", // Exact screen size can be identifying
  // Sensitive content
  "wellnessText",
  "message",
  "notes",
  "text",
  "content",
  // Location data that could identify
  "latitude",
  "longitude",
  "coordinates",
  "gps",
];
